import nvSharedModelsModule from '../nv.shared.models.module';

angular
  .module(nvSharedModelsModule)

  .factory('Report', function(NvBaseModel) {
    const Report = NvBaseModel(
      '/v1/reports/:id/',
      { id: '@_id' },
      {
        // eslint-disable-line new-cap
      },
    );

    Report.extend({});

    return Report;
  });
